$(document).ready(function(){

  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    $("body").addClass("darkmode_visit");
    $("body").removeClass("lightmode_visit");
  } else {
    $("body").addClass("lightmode_visit");
    $("body").removeClass("darkmode_visit");
  }
  
  // testimonial slider
  $('.testimonial_list_slider').slick({
    infinite: false,
    arrows: true,
    appendArrows: '.testimonial_directive_arrows',
    dots: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    prevArrow: "<div class='pre-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.2833 0C10.4021 0 10.5236 0.0469492 10.6147 0.138072C10.797 0.320318 10.797 0.618543 10.6147 0.800789L4.37683 7.04143L10.5236 13.1882C10.7058 13.3704 10.7058 13.6687 10.5236 13.8509C10.3413 14.0332 10.0431 14.0332 9.86088 13.8509L3.38278 7.3728C3.20053 7.19056 3.20053 6.89232 3.38278 6.71007L9.952 0.138086C10.0431 0.0469629 10.1646 2.73438e-05 10.2834 2.73438e-05L10.2833 0Z' fill='white'/></svg></div>",
    nextArrow: "<div class='next-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.71666 0C3.59792 0 3.47641 0.0469492 3.38529 0.138072C3.20305 0.320318 3.20305 0.618543 3.38529 0.800789L9.62317 7.04143L3.47641 13.1882C3.29417 13.3704 3.29417 13.6687 3.47641 13.8509C3.65866 14.0332 3.95687 14.0332 4.13912 13.8509L10.6172 7.3728C10.7995 7.19056 10.7995 6.89232 10.6172 6.71007L4.048 0.138086C3.95687 0.0469629 3.8354 2.73438e-05 3.71664 2.73438e-05L3.71666 0Z' fill='white'/></svg></div>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // grid list js buttons
  $("li.grid-pro").click(function(){
    $(this).addClass("active_opt");
    $("li.listing-pro").removeClass("active_opt");
    $(this).parents(".shop_sec").find(".main-ul").addClass("grid-pro");
    $(".main-ul").removeClass("listing-pro");
  });
    
  $("li.listing-pro").click(function(){
    $(this).addClass("active_opt");
    $("li.grid-pro").removeClass("active_opt");
    $(this).parents(".shop_sec").find(".main-ul").addClass("listing-pro");
    $(".main-ul").removeClass("grid-pro");
  });

  // buy_it_with slider
  $('.buy_it_list').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // logo marquee slider
  var $slider = $('.slick.marquee');
  $slider.slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  // Update Slick options on window resize
  $(window).on('resize', function() {
    $slider.slick('setOption', 'variableWidth', true, true);
  });

  // trending product slider
  $('.trending-product-slider').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: "<div class='pre-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.2833 0C10.4021 0 10.5236 0.0469492 10.6147 0.138072C10.797 0.320318 10.797 0.618543 10.6147 0.800789L4.37683 7.04143L10.5236 13.1882C10.7058 13.3704 10.7058 13.6687 10.5236 13.8509C10.3413 14.0332 10.0431 14.0332 9.86088 13.8509L3.38278 7.3728C3.20053 7.19056 3.20053 6.89232 3.38278 6.71007L9.952 0.138086C10.0431 0.0469629 10.1646 2.73438e-05 10.2834 2.73438e-05L10.2833 0Z' fill='white'/></svg></div>",
    nextArrow: "<div class='next-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.71666 0C3.59792 0 3.47641 0.0469492 3.38529 0.138072C3.20305 0.320318 3.20305 0.618543 3.38529 0.800789L9.62317 7.04143L3.47641 13.1882C3.29417 13.3704 3.29417 13.6687 3.47641 13.8509C3.65866 14.0332 3.95687 14.0332 4.13912 13.8509L10.6172 7.3728C10.7995 7.19056 10.7995 6.89232 10.6172 6.71007L4.048 0.138086C3.95687 0.0469629 3.8354 2.73438e-05 3.71664 2.73438e-05L3.71666 0Z' fill='white'/></svg></div>",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }); 
  
});